import { definePreset } from "@primevue/themes";
import Aura from "@primevue/themes/aura";

const Theme = definePreset(Aura, {
  ripple: true,
  semantic: {
    // Custom palette not in Tailwind config
    orange: {
      50: "#feeeea",
      100: "#fccbbe",
      200: "#fab29e",
      300: "#f88f72",
      400: "#f77956",
      500: "#f5582c",
      600: "#df5028",
      700: "#ae3e1f",
      800: "#873018",
      900: "#672512",
      950: "#40170b",
    },
    // Palettes linked to Tailwind CSS variables (main.css)
    primary: {
      50: "var(--color-primary-50)",
      100: "var(--color-primary-100)",
      200: "var(--color-primary-200)",
      300: "var(--color-primary-300)",
      400: "var(--color-primary-400)",
      500: "var(--color-primary-500)",
      600: "var(--color-primary-600)",
      700: "var(--color-primary-700)",
      800: "var(--color-primary-800)",
      900: "var(--color-primary-900)",
      950: "var(--color-primary-950)",
    },
    secondary: {
      50: "var(--color-secondary-50)",
      100: "var(--color-secondary-100)",
      200: "var(--color-secondary-200)",
      300: "var(--color-secondary-300)",
      400: "var(--color-secondary-400)",
      500: "var(--color-secondary-500)",
      600: "var(--color-secondary-600)",
      700: "var(--color-secondary-700)",
      800: "var(--color-secondary-800)",
      900: "var(--color-secondary-900)",
      950: "var(--color-secondary-950)",
    },
    accent: {
      50: "var(--color-accent-50)",
      100: "var(--color-accent-100)",
      200: "var(--color-accent-200)",
      300: "var(--color-accent-300)",
      400: "var(--color-accent-400)",
      500: "var(--color-accent-500)",
      600: "var(--color-accent-600)",
      700: "var(--color-accent-700)",
      800: "var(--color-accent-800)",
      900: "var(--color-accent-900)",
      950: "var(--color-accent-950)",
    },
    neutral: {
      50: "var(--color-neutral-50)",
      100: "var(--color-neutral-100)",
      200: "var(--color-neutral-200)",
      300: "var(--color-neutral-300)",
      400: "var(--color-neutral-400)",
      500: "var(--color-neutral-500)",
      600: "var(--color-neutral-600)",
      700: "var(--color-neutral-700)",
      800: "var(--color-neutral-800)",
      900: "var(--color-neutral-900)",
      950: "var(--color-neutral-950)",
    },
  },
});

export default {
  preset: Theme,
  options: {
    darkModeSelector: ".p-dark",
  },
};
